import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUser, USER_FIELDS } from '../models/user.model';
import { ApolloService } from '../services/apollo.service';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    constructor(private apolloService: ApolloService) {}

    getUsers(): Observable<any> {
        const query = `
            query GetUserDetails{
                getUserDetails {
                    user {
                        email
                        firstName
                        lastName
                        partner
                        initials
                        userId
                        fleet
                        role
                    }
                    success
                    statusCode
                    message
                }
            }
        `;
        return this.apolloService.query(query).valueChanges
    }

    getUser(id: string): Observable<any> {
        const query = `
            query GetUsers($userId: ID!) {
                getUser(id: $userId) {
                    ...USER_FIELDS
                }
            }
            ${USER_FIELDS}
        `;
        return this.apolloService.query(query, { userId: id }).valueChanges
    }

    updateUser(id: string, user: IUser): Observable<any> {
        const query = `
            mutation Mutation($updateUserId: ID!, $input: UserInput!) {
                updateUser(id: $updateUserId, input: $input) {
                    ...USER_FIELDS
                }
            }
            ${USER_FIELDS}
        `; 
        return this.apolloService.mutate(query, { updateUserId: id, input: user })
    }
}